// // src/hooks/useIssuesData.js
// import { useState, useEffect } from 'react';
// import { fetchIssuesData } from '../services/apis';

// export const useIssuesData = () => {
//   const [issuesData, setIssuesData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const code=localStorage.getItem("code")

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const data = await fetchIssuesData(code);
//         setIssuesData(data);
//         setLoading(false);
//       } catch (err) {
//         setError(err);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [code]);

//   return { issuesData, loading, error };
// };

import { useRender } from "../context/renderContext";
import { useAuth } from "../context/authContext";
import { DEMO_DATA } from "../utils/demoData";

export const useIssuesData = () => {
  const { issuesData } = useRender();
  const { code } = useAuth();
  const demo = DEMO_DATA[code];
  if (demo) {
     if (demo) return { issuesData: demo.issuesData, loading: false, error: null }; // <-- added
  }

  const loading = !issuesData;
  const error = issuesData ? null : "Data not loaded"; // Adjust error handling as needed

  return { issuesData, loading, error };
};
